/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Bottom_RightInputs */

const en_highlight_settings_bottom_right = /** @type {(inputs: Highlight_Settings_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom-right`)
};

const es_highlight_settings_bottom_right = /** @type {(inputs: Highlight_Settings_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abajo a la derecha`)
};

/**
* | output |
* | --- |
* | "Bottom-right" |
*
* @param {Highlight_Settings_Bottom_RightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_bottom_right = /** @type {((inputs?: Highlight_Settings_Bottom_RightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Bottom_RightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_bottom_right(inputs)
	return en_highlight_settings_bottom_right(inputs)
});